import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { upload, languageChange, setLoadingVisible } from 'store/siteConfig'

export default function(route) {
  const Detail = Loadable({
    loader: () => import('./Detail'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          riskDetailState: state.riskDetailState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          submit,
          upload,
          languageChange,
          setLoadingVisible
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/detail`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Detail {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
